var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVirtualTryOnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 9.33333C14 8.87184 14.1368 8.42072 14.3932 8.037C14.6496 7.65329 15.014 7.35422 15.4404 7.17762C15.8668 7.00101 16.3359 6.9548 16.7885 7.04484C17.2412 7.13487 17.6569 7.3571 17.9832 7.68342C18.3096 8.00974 18.5318 8.4255 18.6218 8.87812C18.7119 9.33075 18.6657 9.7999 18.4891 10.2263C18.3124 10.6526 18.0134 11.017 17.6297 11.2734C17.2459 11.5298 16.7948 11.6667 16.3333 11.6667C16.3333 13.0667 15.1667 13.4167 14 14",
    stroke: "#8F333B",
    strokeWidth: 2.04167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0002 14L23.9168 20.4167C24.1304 20.5488 24.2956 20.7464 24.3879 20.98C24.4802 21.2135 24.4947 21.4707 24.4292 21.7131C24.3636 21.9556 24.2216 22.1704 24.0242 22.3257C23.8268 22.481 23.5846 22.5684 23.3335 22.575H4.66683C4.41576 22.5684 4.17352 22.481 3.97612 22.3257C3.77872 22.1704 3.6367 21.9556 3.57117 21.7131C3.50564 21.4707 3.52011 21.2135 3.61241 20.98C3.70471 20.7464 3.86993 20.5488 4.0835 20.4167L14.0002 14Z",
    stroke: "#8F333B",
    strokeWidth: 2.04167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtualTryOnIcon);
export default __webpack_public_path__ + "static/media/virtual-try-on-icon.c39309b08aa4f08a3ed30b358338df20.svg";
export { ForwardRef as ReactComponent };